import { DivisionsFilter } from '@gettactic/api';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { useTacticHooks } from '../providers/TacticHooksProvider';

export const useDivisionsQuery = (filter: DivisionsFilter = {}) => {
  const { apiClient } = useTacticHooks();
  const divisions = useQuery({
    queryKey: ['useDivisionsQuery', apiClient.slug, filter],

    queryFn: async () => {
      const res = await apiClient.divisions.all(filter);
      return res.result;
    },

    enabled: !!apiClient.slug
  });
  const computed = useMemo(() => {
    const hasDivisions = (divisions.data?.length ?? 0) > 0;
    const divisionsOptions = (divisions.data ?? []).map((x) => ({
      label: x.name,
      parent_id: x.parent_id,
      value: x.id
    }));
    divisionsOptions.unshift({
      label: '-- No division --',
      value: '',
      parent_id: ''
    });
    return {
      hasDivisions,
      divisionsOptions
    };
  }, [divisions.data]);

  return {
    divisions,
    ...computed
  };
};
